import { formatPrismicImage } from '~/helpers/image-helper';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import RegularTitle from '~/components/atoms/Global/RegularTitle.vue';
import PricingPlan from '~/components/organisms/Editorial/Pricing/PricingPlan.vue';
export default {
  name: 'PricingPlanList',
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  components: {
    SimpleParagraph,
    PricingPlan,
    RegularTitle
  },
  computed: {
    primarySlice() {
      var _this$payload;
      return (_this$payload = this.payload) === null || _this$payload === void 0 ? void 0 : _this$payload.primary;
    },
    payloadInterface() {
      var _this$payload$primary, _this$payload2, _this$payload2$primar, _this$payload$primary2, _this$payload3, _this$payload3$primar, _this$payload$primary3, _this$payload4, _this$payload4$primar, _this$payload5, _this$payload5$items;
      return {
        primarySlice: {
          title: (_this$payload$primary = (_this$payload2 = this.payload) === null || _this$payload2 === void 0 ? void 0 : (_this$payload2$primar = _this$payload2.primary) === null || _this$payload2$primar === void 0 ? void 0 : _this$payload2$primar.title) !== null && _this$payload$primary !== void 0 ? _this$payload$primary : [],
          paragraph: (_this$payload$primary2 = (_this$payload3 = this.payload) === null || _this$payload3 === void 0 ? void 0 : (_this$payload3$primar = _this$payload3.primary) === null || _this$payload3$primar === void 0 ? void 0 : _this$payload3$primar.paragraph) !== null && _this$payload$primary2 !== void 0 ? _this$payload$primary2 : [],
          background_color: (_this$payload$primary3 = (_this$payload4 = this.payload) === null || _this$payload4 === void 0 ? void 0 : (_this$payload4$primar = _this$payload4.primary) === null || _this$payload4$primar === void 0 ? void 0 : _this$payload4$primar.background_color) !== null && _this$payload$primary3 !== void 0 ? _this$payload$primary3 : '#f8f8f8'
        },
        items: (_this$payload5 = this.payload) === null || _this$payload5 === void 0 ? void 0 : (_this$payload5$items = _this$payload5.items) === null || _this$payload5$items === void 0 ? void 0 : _this$payload5$items.map(item => {
          var _item$header, _item$header_bg_color, _item$title, _item$subtitleRich, _item$basePrice, _item$subPrice, _item$subPrice_strike, _item$image$alt, _item$cta_theme, _item$url, _item$paragraph_title, _item$paragraph, _item$event_category, _item$event_action, _item$event_label;
          return {
            header: (_item$header = item.header) !== null && _item$header !== void 0 ? _item$header : [],
            headerBgColor: (_item$header_bg_color = item.header_bg_color) !== null && _item$header_bg_color !== void 0 ? _item$header_bg_color : '#ffc863',
            title: (_item$title = item.title) !== null && _item$title !== void 0 ? _item$title : '',
            subtitleRich: (_item$subtitleRich = item.subtitleRich) !== null && _item$subtitleRich !== void 0 ? _item$subtitleRich : [],
            basePrice: (_item$basePrice = item.basePrice) !== null && _item$basePrice !== void 0 ? _item$basePrice : [],
            subprice: (_item$subPrice = item.subPrice) !== null && _item$subPrice !== void 0 ? _item$subPrice : '',
            subpriceStrike: (_item$subPrice_strike = item.subPrice_strike) !== null && _item$subPrice_strike !== void 0 ? _item$subPrice_strike : false,
            image: {
              small: formatPrismicImage(item.image.url, ['w_130,dpr_2']),
              alt: (_item$image$alt = item.image.alt) !== null && _item$image$alt !== void 0 ? _item$image$alt : ''
            },
            cta: item.cta,
            cta_theme: (_item$cta_theme = item.cta_theme) !== null && _item$cta_theme !== void 0 ? _item$cta_theme : 'dark',
            link: (_item$url = item.url) !== null && _item$url !== void 0 ? _item$url : {},
            paragraphTitle: (_item$paragraph_title = item.paragraph_title) !== null && _item$paragraph_title !== void 0 ? _item$paragraph_title : [],
            paragraph: (_item$paragraph = item.paragraph) !== null && _item$paragraph !== void 0 ? _item$paragraph : [],
            tracking: {
              data: {
                event_category: (_item$event_category = item.event_category1) !== null && _item$event_category !== void 0 ? _item$event_category : '',
                event_action: (_item$event_action = item.event_action1) !== null && _item$event_action !== void 0 ? _item$event_action : '',
                event_label: (_item$event_label = item.event_label1) !== null && _item$event_label !== void 0 ? _item$event_label : ''
              }
            }
          };
        })
      };
    }
  }
};